import React from 'react';
import AmountInput from './AmountInput';
import { useAuth } from '../../../../contexts/AuthContext';
import { useConnect } from 'wagmi';
import { injected } from 'wagmi/connectors';

// 简化的连接钱包按钮组件
function ConnectWalletButton() {
  const { connect } = useConnect();
  
  const handleConnect = () => {
    connect({ connector: injected() });
  };
  
  return (
    <button
      onClick={handleConnect}
      className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors text-[12px] h-7 items-center justify-center flex"
    >
      CONN WALLET
    </button>
  );
}

/**
 * 下注卡片背面组件
 * 显示当前价格、金额输入和下注按钮
 */
export default function CardBack({ period, data, lastPrice, amount, onAmountChange, onPredict }) {
  const { isLoggedIn } = useAuth();
  
  // console.log('🃏 CardBack 渲染, isLoggedIn:', isLoggedIn);
  const getColorClasses = (minutes) => {
    if (minutes === 5) {
      return {
        label: 'bg-blue-500/40 text-blue-100',
        button: 'bg-blue-500 hover:bg-blue-600 text-white'
      };
    } else if (minutes === 15) {
      return {
        label: 'bg-purple-500/40 text-purple-100',
        button: 'bg-purple-500 hover:bg-purple-600 text-white'
      };
    } else {
      return {
        label: 'bg-orange-500/40 text-orange-100',
        button: 'bg-orange-500 hover:bg-orange-600 text-white'
      };
    }
  };

  const colors = getColorClasses(period.minutes);

  return (
    <div className="absolute inset-0 backface-hidden rotate-y-180 rounded-lg backdrop-blur-sm border border-white/10 shadow-md bg-[#22283a]/80">
      {/* 左上角标签 */}
      <div className="absolute top-0 left-0 z-10">
        <div className={`px-1.5 py-0.5 rounded-br text-xs font-bold ${colors.label}`}>
          {data.label}
        </div>
      </div>

      <div className="relative p-3 pt-5 h-full flex flex-col justify-center">
        {/* 当前现价 */}
        <div className="text-center mb-2">
          <div className="text-sm font-bold text-white">
            ${lastPrice.toLocaleString()}
          </div>
        </div>

        {/* 金额输入 */}
        <div className="mb-2">
          <AmountInput
            value={amount}
            onChange={onAmountChange}
          />
        </div>

        {/* 下注按钮 */}
        {isLoggedIn ? (
          <div className="flex gap-1">
            <button
              onClick={() => onPredict('green')}
              className="flex-1 py-1.5 text-xs font-bold rounded transition-all duration-200 bg-green-500 hover:bg-green-600 text-white h-6 flex items-center justify-center"
            >
              UP
            </button>
            <button
              onClick={() => onPredict('red')}
              className="flex-1 py-1.5 text-xs font-bold rounded transition-all duration-200 bg-red-500 hover:bg-red-600 text-white h-6 flex items-center justify-center"
            >
              DOWN
            </button>
          </div>
        ) : (
          <div className="w-full">
            <ConnectWalletButton />
          </div>
        )}
      </div>
    </div>
  );
}
